import { render } from "./WorksList.vue?vue&type=template&id=14b6772e"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__